<template>
  <div class="search">
    <Row :gutter="4">
      <div v-if="companyIdShow == 1">
        <Col span="5">
          <Select
            v-model="companyId"
            @on-change="changeCompanyId"
            :placeholder="$t('RAM.common.company')"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="5">
          <!--按账户筛选  -->
          <Select
            v-model="accountIds"
            filterable
            multiple
            :max-tag-count="1"
            :placeholder="$t('RAM.common.pleaseEnterAccount')"
            @on-change="changeAccountId(accountIds)"
            :transfer="true"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block;text-align:right;"
              v-if="accountIdList.length > 0"
              >{{ $t("alarms.common.allSelected") }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountIdList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="5">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="5">
        <Input v-model="natGatewayId" :placeholder="$t('RAM.common.QueryByNatGatewayId')" />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:natGatewayResource:page'
          ]"
          @click="search()"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableNatGatewayResource from "../nat_gateway/TableNatGatewayResource";
var tableNatGatewayResource = TableNatGatewayResource;
export default {
  name: "NatGatewayResourceSearch",
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      natGatewayId: "",
      accountIds: [],
      accountIdList: [],
      singleAccount: false
    };
  },
  mounted: function() {
    if (this.companyIdShow == 1) {
      this.listRegisterInformation();
    } else {
      // tableNatGatewayResource.methods.showAll();
    }
  },
  methods: {
    //查询账号
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountIds = [];
        this.getAWSAccountByCompanyId();
      });
    },
    getAWSAccountByCompanyId: function() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.companyId)
        .then(res => {
          this.accountIdList = res.data;
          //默认账户全选
          if (this.accountIdList) {
            for (var i = 0; i < this.accountIdList.length; i++) {
              this.accountIds.push(this.accountIdList[i].id);
            }
          }
        });
    },
    // 切换公司
    changeCompanyId: function() {
      this.accountIds = [];
      this.getAWSAccountByCompanyId();
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountIdList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountIds = [];
      if (this.singleAccount) {
        this.accountIdList.map(item => {
          this.accountIds.push(item.id);
        });
      } else {
        this.accountIds = [];
      }
    },
    search: function() {
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountIds", this.accountIds);
      eventBus.$emit("natGatewayId", this.natGatewayId);
      tableNatGatewayResource.methods.showAll();
    }
  }
};
</script>
<style scoped>
.search {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/nat_gateway/NatGatewayResourceSearch.vue